import React, { useEffect } from 'react';
import { t, Trans } from '@lingui/macro';
import Message, { THEME } from '@mos-cat/message';
import Link from '../Link/Link';
import { i18n } from '../../../helpers/i18n';
import { PASSPORT_STATUS } from '../../../constants/document';
import {
  passportStatus,
  PassportStatusStat,
  sendStats,
} from '../../../helpers/stats';
import { sendCMABusinessError } from '../../../helpers/CMAstats';

interface Props {
  status: string;
  passportDueDate: string;
}

function InstructionLink() {
  return (
    <Link
      href={i18n._(
        t`https://www.mos.ru/otvet-dokumenti/kak-zamenit-ili-vosstanovit-obschegrazhdanskiy-pasport/`
      )}
      target="_blank"
    >
      инструкции
    </Link>
  );
}

function DocumentWarning(props: Props): JSX.Element | null {
  const { passportDueDate, status } = props;
  useEffect(() => {
    if (PassportStatusStat[status]) {
      sendStats(passportStatus(PassportStatusStat[status]));
      sendCMABusinessError('step');
    }
    if (status === PASSPORT_STATUS.EXPIRED) {
      sendCMABusinessError('step');
    }
  }, [status]);
  if (status === PASSPORT_STATUS.VALID) return null;

  const themeType =
    status === PASSPORT_STATUS.EXPIRING ? THEME.ATTENTION : THEME.DANGER;

  return (
    <Message theme={themeType} className="DocumentWarning">
      {status === PASSPORT_STATUS.EXPIRING ? (
        <span>
          Срок действия паспорта заканчивается {passportDueDate}. Для подачи
          заявки после этой даты вам понадобится новый паспорт. Подробнее о его
          получении — в <InstructionLink />.
        </span>
      ) : (
        <span>
          Паспорт недействителен. Для подачи заявки вам понадобится новый
          паспорт. Подробнее о его получении — в <InstructionLink />.
        </span>
      )}
    </Message>
  );
}

export default DocumentWarning;
